import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import MainContent from '@components/main/MainContent'
import MainHeader from '@components/main/MainHeader'
import { useAuthStore } from '@stores/authStore'

function MainHomePage() {
  const location = useLocation()
  const session = useAuthStore((state) => state.session)
  const loadSession = useAuthStore((state) => state.loadSession)

  useEffect(() => {
    void loadSession()
  }, [loadSession])

  if (session && !session.authenticated) {
    const next = `${location.pathname}${location.search}${location.hash}`
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />
  }

  return (
    <main className="min-h-svh bg-slate-50 text-slate-950 dark:bg-zinc-950 dark:text-slate-100">
      <MainHeader />

      <div className="h-[calc(100svh-4rem)] min-h-0 max-[820px]:h-auto">
        <MainContent />
      </div>
    </main>
  )
}

export default MainHomePage
